import axios from "axios";
import { emitUnauthorized } from "./authEvents";
import { apiBaseUrl } from "../constants/config";

const instance = axios.create({
    baseURL: apiBaseUrl
});

// Добавляем интерцептор для автоматической подстановки токена
instance.interceptors.request.use((config) => {
    const token = JSON.parse(localStorage.getItem('admin'))?.token;
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
});

// При 401 сообщаем о недействительной сессии, не зная про Redux.
// Логин (неверный пароль) исключаем — им занимается loginAdmin.rejected.
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const url = error.config?.url || '';
            const isLoginRequest = url.includes('/admin/login');
            if (!isLoginRequest) {
                emitUnauthorized();
            }
        }
        return Promise.reject(error);
    }
);

export default instance;